import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { HelpIconTooltip } from "../HelpIconTooltip/HelpIconTooltip";

interface SearchTitleProps {
  tooltipTitle?: NonNullable<React.ReactNode>;
}

export function SearchTitle({ tooltipTitle = "Поиск" }: SearchTitleProps) {
  return (
    <Grid container>
      <Grid item>
        <Typography noWrap variant={"subtitle2"} color={"primary"} gutterBottom={false}>
          <Grid container justify={"flex-start"} alignItems={"center"} direction={"row"} wrap={"nowrap"}>
            <Grid item container>
              Поиск
            </Grid>
            <Grid item container>
              <HelpIconTooltip title={tooltipTitle} />
            </Grid>
          </Grid>
        </Typography>
      </Grid>
    </Grid>
  );
}
